import React from 'react';
import '../../assets/css/solutionlist.css';
import {Line} from '@vds/lines';
import styled from 'styled-components';
import { CMS_LOCATION } from '../../constants/constants';
import { isNullOrUndefined, getOS, saveMetrics, makeCall, checkUrlPath } from "../modules/CommonFunctions";
import { MetricRTCICall } from "./RTCICall";
import { HOME_PAGE_CATEGORY } from '../../constants/constants';
import Icon from '@vds/icons';
import { Title, Body } from '@vds/typography';
import {setNativeTitleWithNavigation, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar,nativeUpdateFab} from "../../actions/native";
import CaretImage from "../../assets/resources/images/caret.png";

const StyledLineNext = styled.div `height:3px`
const StyledBody = styled.div`padding-left:20px`


export const SolutionsList = ({PegaSessionID, Title, Items, BannerImage}) => {
    if(BannerImage !== "") {
        let altText = BannerImage.substring(BannerImage.lastIndexOf('/') + 1, BannerImage.lastIndexOf('.'));
        return (
            <React.Fragment>
                <RenderTopSolution ListTitle={Title} ListItem={Items} pegaID={PegaSessionID} careticon={CaretImage}/>
                <div className="column small-banner">
                            <img role="presentation" src={CMS_LOCATION+ BannerImage}/>
                </div>
            </React.Fragment>
        )
    } else {
        return (<RenderTopSolution ListTitle={Title} ListItem={Items} pegaID={PegaSessionID} careticon={CaretImage}/>)
    }

}

function topSolutionscallBack(solutionItem, pegaSessionID) {
    localStorage.setItem('IsContactLoaded',true); 
    let SolutionTitle = solutionItem.linktext;
    setNativeTitleWithNavigation(SolutionTitle, true);
    nativeUpdateFab(true);
    // if(!isNullOrUndefined(solutionItem.savemetricksId)) {
    //     saveMetrics(solutionItem.savemetricksId);
    // }
    if(!isNullOrUndefined(solutionItem.sclinktrackid)) {
        //window.scLinkTrackID(solutionItem.sclinktrackid);
    }
    // if(!isNullOrUndefined(solutionItem.makecall)) {
    //     let args = solutionItem.makecall.split(',');
    //     makeCall(...args);
    // }
    let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: pegaSessionID,
            userid: window.userinfo.userId,
            visionID : window.userinfo.visionId,
            accountID: window.userinfo.visionAcctId
    }
    //window.constructScData('tab', SolutionTitle);
    // MetricRTCICall(args);
}

function RenderTopSolution(ListItems){

    return <div className="column  top-solutions-list">    <h1 className="top-solutions-header minus">{ListItems.ListTitle }</h1>
    <div className="top-solutions-summary">
        <ul>
            {
                ListItems.ListItem.map((item, index) => {
                   return (
                       <div className="Solutionlistfocus">
                           <a href={checkUrlPath(item.linkurl) } aria-label={item.linktext + " link double tap to activate"}  data-track={item.linktext} onClick={() => topSolutionscallBack(item, ListItems.pegaID)} tabIndex="0" className="SolutionListremovelink">
                               <div className="MainFreuent">
                                   <StyledBody>
                               <span primitive="p" size="small"  viewport="mobile">
                               { item.linktext }
                                    </span> </StyledBody>                            
                               <div className="CarectArrowFlequent">
                                    <span className="CaretArrow"> 
                                        <img src={ListItems.careticon} alt=" " aria-hidden="true" ></img> 
                                    </span>
                                </div>
                             </div>
                       <div className="Helorow" > 
                         <StyledLineNext>
                         <Line type="xLight"/>
                         </StyledLineNext>
                       </div>
                       </a>
                   </div>
                       
                   )
                    
                })
            }
        </ul>
    </div>
</div>
}



// WEBPACK FOOTER //
// ./src/components/modules/SolutionListOneApp.js